<template>
  <section class="checkin-maker">
    <form class="checkin-form w-100">
      <div class="checkin-form-in">
        <div class="text-danger my-2 text-center small text-uppercase w-100" v-if="hasPicaCodeNotValidError">
          {{ $t('pages.checkins_list.tips_form_invalid_code') }}
        </div>
        <b-input maxlength="10"
                 type="text"
                 v-model="picacode"
                 ref="inputPicacode"
                 @focus="hasPicaCodeNotValidError = false"
                 class="checkin-form-picacode"
                 :placeholder="$t('pages.checkins_list.tips_form_placeholder')"/>
      </div>
      <div class="row">
        <div class="order-sm-1 mb-2 mb-sm-0" :class="[dismissible ? 'col-sm-6': 'col-12' ]">
          <button-with-spinner class="btn btn-primary btn-block" @click="doCheckin" :loading="loading">
            {{ $t('pages.checkins_list.tips_form_submit') }}
          </button-with-spinner>
        </div>
        <div class="col-sm-6 order-sm-0" v-if="dismissible">
          <b-button block variant="light" @click="$bvModal.hide('bv-modal-checkin-maker')">
            {{ $t('pages.checkins_list.tips_form_cancel') }}
          </b-button>
        </div>
      </div>

      <a class="d-inline-block mt-3"
         v-if="hasPicaCodeNotValidError"
         :href="getContactUrl()"
         target="_blank">{{ $t('pages.checkins.tips_help') }}</a>
    </form>
  </section>
</template>


<script>
import ButtonWithSpinner from '@/components/ButtonWithSpinner'
import {getContactUrl} from "@/utils";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {CheckinAlreadyExistForUser, NextStepRequired} from "@/domain/autologin/exceptions";

export default {
  components: {ButtonWithSpinner},
  data() {
    return {
      picacode: '',
      hasPicaCodeNotValidError: false,
      loading: false
    }
  },

  props: {
    dismissible: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters('checkin', [
      'stepData',
    ]),
  },


  methods: {
    ...mapActions('checkin', [
      'createCheckin',
      'openStepModal',
    ]),
    ...mapMutations('digitalItems', ['CLEAR_CHECKINS']),
    getContactUrl,
    async doCheckin() {
      this.hasPicaCodeNotValidError = false
      this.loading = true
      sessionStorage.setItem('recover_picacode', this.picacode)
      try {
        await this.createCheckin({picacode: this.picacode})
        await this.$router.push({
          name: 'checkins-detail',
          params: {picacode: this.picacode.toUpperCase()}
        })
      } catch (e) {
        if (e instanceof NextStepRequired) {
          this.openStepModal()
        } else if (e instanceof CheckinAlreadyExistForUser) {
          const currentRoute = this.$route
          if (currentRoute.name === 'checkins-detail' && currentRoute.params.picacode === e.getPicacode()) {
            this.$router.go()
          } else {
            await this.$router.push({
              name: 'checkins-detail',
              params: {picacode: e.getPicacode()}
            })
          }
          this.$bvModal.hide('bv-modal-checkin-maker')
        } else {
          this.hasPicaCodeNotValidError = true
        }
      }

      this.loading = false
      this.picacode = ''
    },
  }
}
</script>
